"use client";

import {
  INITIAL_SEARCH_PAGE_DATA,
  SearchPageData,
} from "@faire/deprecated-retailer-visitor-shared/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageData";
import React, { createContext, ReactNode, useContext } from "react";

const SearchPageDataContext = createContext<SearchPageData>(
  INITIAL_SEARCH_PAGE_DATA
);

export const SearchPageDataContextProvider = ({
  children,
  searchPageData,
}: {
  children: ReactNode;
  searchPageData: SearchPageData;
}) => {
  return (
    <SearchPageDataContext.Provider value={searchPageData}>
      {children}
    </SearchPageDataContext.Provider>
  );
};

export const useSearchPageDataContext = () => {
  // Could replace this with React use and Suspense
  const value = useContext(SearchPageDataContext);
  if (value === INITIAL_SEARCH_PAGE_DATA) {
    throw new Error(
      "useSearchPageDataContext must be used within a SearchPageDataContextProvider"
    );
  }
  return value;
};
